export default "/images/vendor/flag-icon-css/flags/4x3/ad.svg?45026b922ec57f969a0a19debde23320";